<template>
    <div class="fourSymbolsLineDiagram">
        <div :id="'ElephantLine_' + id_type" class="ElephantLine"></div>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['id_type', 'ownexamData'],
    data() {
        return {

        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        initChart() {
            let that = this;
            this.$echarts.init(document.getElementById(`ElephantLine_${this.id_type}`)).dispose();
            let myChart = this.$echarts.init(document.getElementById(`ElephantLine_${this.id_type}`));
            myChart.setOption({
                title: {
                    text: that.ownexamData[0].exam_name + ' ' + this.dayjs(that.ownexamData[0].create_at).format("YYYY-MM-DD"),
                    left: 'center',
                    textStyle: {
                        fontWeight: "normal",
                        fontSize: 13
                    },
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: function (params) {
                        return `姓名: ${params.data.user_name}<br/>努力: ${params.data.value[0]}<br/>天赋: ${params.data.value[1]}`;
                    },
                    position: 'right'
                },
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: -100,
                        endValue: 100,
                    }
                ],
                grid: {
                    left: '15%',
                    right: '15%',
                },
                xAxis: {
                    type: 'value',
                    // name: '努力常模',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                    },
                    splitLine: {
                        show: false
                    },
                    interval: 10,
                },
                yAxis: {
                    type: 'value',
                    // name: '天赋常模',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                    },
                    splitLine: {
                        show: false
                    },
                    interval: 10,
                },
                series: [{
                    type: 'scatter',
                    data: that.generateData(),
                    // symbol: 'diamond',
                    markLine: {
                        symbol: ['none', 'arrow'],
                        silent: true,
                        lineStyle: {        // 👈 添加这一块
                            type: 'solid',  // 👈 设置为实线
                            width: 1,
                            color: '#333'   // 可选：设置颜色
                        },
                        // data: [
                        //     { xAxis: 69.32 },
                        //     { yAxis: 64.75 }
                        // ]
                        data: [
                            {
                                xAxis: 69.32, // 纵轴线
                                label: {
                                    show: true,
                                    position: 'start',
                                    formatter: '大众型'
                                }
                            },
                            {
                                yAxis: 64.75, // 横轴线
                                label: {
                                    show: true,
                                    position: 'start',
                                    formatter: '自然成长'
                                },

                            },
                            {
                                xAxis: 69.32, // 纵轴线
                                label: {
                                    show: true,
                                    position: 'end',
                                    formatter: '天赋型'
                                }
                            },
                            {
                                yAxis: 64.75, // 横轴线
                                label: {
                                    show: true,
                                    position: 'end',
                                    formatter: '笃行不倦'
                                }
                            }
                        ],
                    }
                }],

            })
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        generateData() {
           
            
            let data = [];
            let quadrant1 = []; // 存储第1象限的数据（用于分析）
            const thresholdX = 69.32; // 努力常模基准线
            const thresholdY = 64.75; // 天赋常模基准线
            // 1. 筛选第1象限数据，并计算比例（Y/X：天赋 / 努力），避免 x=0
            for (let item of this.ownexamData) {
                // 跳过无效数据
                if (!item || typeof item.x !== 'number' || typeof item.y !== 'number') continue;

                if (item.x > thresholdX && item.y > thresholdY) {
                    const ratio = item.x !== 0 ? item.y / item.x : Infinity; // x=0 时视为“极高天赋比”
                    quadrant1.push({ ...item, ratio });
                }
            }

            // 2. 找出比例最高和最低的点（注意边界情况）
            let minItem = null;
            let maxItem = null;

            if (quadrant1.length === 1) {
                minItem = maxItem = quadrant1[0]; // 只有一个点，既是最高也是最低
            } else if (quadrant1.length > 1) {
                // 按 ratio 升序排序
                quadrant1.sort((a, b) => a.ratio - b.ratio);
                minItem = quadrant1[0];
                maxItem = quadrant1[quadrant1.length - 1];
            }
            // 如果 quadrant1.length === 0，则 minItem 和 maxItem 保持 null

            // 3. 生成 series 数据
            for (let item of this.ownexamData) {
                // 安全判断：防止 null 访问 .id
                const isMax = maxItem && item.id == maxItem.id; // 使用 == 允许类型转换（如 string vs number）
                const isMin = minItem && item.id == minItem.id && !isMax; // 避免同一人重复标记两种颜色

                data.push({
                    value: [item.x, item.y],
                    itemId: item.test_id,
                    user_name: item.user_name,
                    createAt: item.create_at,
                    // symbolSize: isMax ? 16 : (isMin ? 14 : 12),
                    symbolSize: 12,
                    itemStyle: {
                        // color: isMax
                        //     ? '#00b487'
                        //     : (isMin ? '#e96f2a' : '#5470C6'),
                        // color: isMax
                        //     ? '#00b487'
                        //     : '#5470C6',
                        color: '#5470C6',
                        borderColor: '#fff',
                        // borderWidth: isMax || isMin ? 2 : 0
                        borderWidth: 0
                    },
                    label: {
                        show: false, // 始终显示标签（也可改为 isMax || isMin）
                        position: 'top',
                        formatter: () => {
                            // if (isMax) return `${item.user_name} ↑(比例最高)`;
                            // if (isMin) return `${item.user_name} ↓(比例最低)`;
                            return item.user_name; // 其他只显示姓名
                            // return ''; // 其他只显示姓名
                        },
                        // fontSize: isMax ? 15 : (isMin ? 13 : 12),
                        fontSize: 13,
                        // fontWeight: isMax || isMin ? 'bold' : 'normal',
                        fontWeight: 'normal',
                        // color: isMax
                        //     ? '#00b487'
                        //     : (isMin ? '#e96f2a' : '#333')
                        // color: isMax
                        //     ? '#00b487'
                        //     : '#333'
                        color: '#333'
                    }
                });
            }

            return data;
        }
    },

    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.initChart();
    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style scoped lang="less">
.fourSymbolsLineDiagram {
    width: 100%;
    height: 100%;

    .ElephantLine {
        width: 100%;
        height: 100%;
    }
}
</style>